
import React, { useEffect, useRef, useState } from 'react'
import SuccessImg from '../Images/successImg.svg'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import Lang from '../Images/lang.svg'
import { useSelector } from 'react-redux';
import Cross from '../Images/cross.png'

function Success() {
    const { mandateData } = useSelector((state) => state.mandateInfo);
    const Ref = useRef(null);
    const [timer, setTimer] = useState("00:00:00");

    const getTimeRemaining = (e) => {
        const total =
            Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor(
            (total / 1000 / 60) % 60
        );
        const hours = Math.floor(
            (total / 1000 / 60 / 60) % 24
        );
        return {
            total,
            hours,
            minutes,
            seconds,
        };
    };

    const startTimer = (e) => {
        let { total, hours, minutes, seconds } =
            getTimeRemaining(e);
        if (total >= 0) {
            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable
            setTimer(
                // (hours > 9 ? hours : "0" + hours) +
                // ":" +
                // (minutes > 9
                //     ? minutes
                //     : "0" + minutes) +
                // ":" +
                (seconds > 9 ? seconds : "0" + seconds)
            );
        }
    };

    const clearTimer = (e) => {
        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next
        setTimer(mandateData?.time);

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + +mandateData?.time);
        return deadline;
    };

    // We can use useEffect so that when the component
    // mount the timer will start as soon as possible

    // We put empty array to act as componentDid
    // mount only
    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    useEffect(() => {
        setTimeout(function () { redirectFnc(mandateData?.redirect_url); }, (+mandateData?.time*1000));
    }, [mandateData])
    const redirectFnc = (url) => {
        url ? window.location.assign(url) : console.log("not working")
    }
    return (
        // <div className="container Payment-way-page">
        //     <div className="row">
        //                 <div className="col-12 text-center mt-4"> <img src={cholaLogo} className="img-fluid" alt="" />
        //                     <p className="Pay_way mt-3">Cholamandalam Investment and <br />
        //                         Finance Company Limited</p>
        //                 </div>
        //             </div>
        //     <div className="col-md-12">
        //         <div className="Title-Menu d-flex align-items-center">
        //         </div>
        //     </div>
        //     <div className="pageCent">
        //         <div className="col-12">
        //             <div className="mt-5">
        //                 <div className="col-md-12 text-center">
        //                     <img src={SuccessImg} alt="success" />
        //                 </div>
        //             </div>
        //             {/* <div className="col-md-12 text-center">
        //                 <p className="fs-5 mt-4 mb-2">Thank you! The mandate has been succesfully done.
        //                 </p>
        //             </div> */}
        //             <div className="col-md-12 text-center mt-4">
        //                 <div className="mb-2">
        //                     <span className="fs-5 fw-semibold">Mandate successfully completed</span>
        //                     {mandateData?.UMRNNumber && <label className="d-block sec-grey fs-5" style={{wordWrap:"break-word"}}>UMRN No : {mandateData?.UMRNNumber}
        //                     </label>}
        //                 </div>
        //             </div>
        //             {mandateData?.redirect_url && 
        //             <div className="col-md-12 text-center mt-2">
        //             <div className="mb-5">
        //                 <label className="d-block sec-grey fs-5" style={{wordWrap:"break-word"}}>Please wait while the site redirects in (countdown of {timer} seconds) seconds
        //                 </label>
        //             </div>
        //         </div>}
        //             {/* <div className="row btn-btm justify-content-center">
        //                 <a href={hashUrl} className="fs-5 d-block mt-4 text-center" onClick={() => {
        //                     updatePage()
        //                 }}>Proceed</a>
        //             </div> */}
        //             {/* <div className='row'>
        //                 <div className="col-12">
        //                     <button className="btn btn-primary w-100 Proceed_btn" type='button'
        //                     // onClick={checkOpt}
        //                     >Proceed</button>
        //                 </div></div> */}
        //         </div>
        //     </div>
        // </div>
        <div class="container in-spacer">
            <div class="row">
                <div class="col-12">
                    <div class="success">
                        <img src={mandateData?.npciStatus === 'Failure' && Cross || SuccessImg} class="img-fluid mb-4"/>
                            <div>
                                {/* <h6>Your Mandate has been Successfully Completed</h6> */}
                                {mandateData?.UMRNNumber && <p class="mb-1">{mandateData?.UMRNNumber}</p>}
                                <small class="text-secondary">Please wait while the site redirects in <br/>
                                    (countdown of {timer} seconds)</small>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                        <div class="container">
                            <a class="navbar-brand-sm" href="#">
                                <img src={cholaLogo} alt="Chola Logo"/>
                            </a>
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    {/* <a class="nav-link" href="Language.html">
                                        <img src={Lang}/>
                                    </a> */}
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Success